<template>
  <div class="changePassword">
    <v-form ref="form" @submit.prevent="submit" lazy-validation>
      <div class="changePassword__icon" data-test="change-password-icon">
        <CSSVGIcon iconName="shield-lock-color" />
      </div>

      <div class="changePassword__title" data-test="change-password-title">
        {{ translate('PLEASE_CHOOSE_PASSWORD') }}
      </div>

      <div
        class="changePassword__description"
        data-test="change-password-description"
      >
        {{ translate('PASSWORD_DESCRIPTION') }}
      </div>

      <div
        class="changePassword__requirements"
        data-test="change-password-requirements"
      >
        {{ translate('PASSWORD_MIN_LENGTH_HINT') }}
      </div>

      <div class="changePassword__inputs" data-test="change-password-inputs">
        <MatchingPassword
          :onPasswordChange="onPasswordChange"
          :onRepeatPasswordChange="onRepeatPasswordChange"
          passwordPlaceholderKey="ENTER_PASSWORD"
          repeatPasswordPlaceholderKey="ENTER_PASSWORD_AGAIN"
        />
      </div>

      <div class="changePassword__submitBtnContainer">
        <CSButton
          class="changePassword__submitBtn"
          id="submit-password-btn"
          data-test="change-password-submit-btn"
          :text="translate('SAVE_PASSWORD')"
          @click="submit(password)"
          :loading="isLoading"
        />
      </div>
    </v-form>
  </div>
</template>

<script>
import CSButton from '@/components/atoms/button/CSButton.vue'
import CSSVGIcon from '@/components/atoms/icons/CSSVGIcon.vue'
import MatchingPassword from '@/components/molecules/password/matchingPassword.vue'

export default {
  name: 'ChangePassword',

  data() {
    return {
      password: '',
      repeatPassword: '',
      isLoading: false,
    }
  },

  components: {
    CSSVGIcon,
    CSButton,
    MatchingPassword,
  },

  props: {
    handleSubmit: {
      type: Function,
      required: true,
    },
  },

  methods: {
    onPasswordChange(password) {
      this.password = password
    },

    onRepeatPasswordChange(password) {
      this.repeatPassword = password
    },

    async submit(password) {
      if (!this.$refs.form.validate()) {
        return
      }

      try {
        this.isLoading = true
        await this.handleSubmit(password)
        setTimeout(() => {
          this.isLoading = false
        }, 500)
      } catch (error) {
        this.isLoading = false
      }
    },
  },
}
</script>
